export default __webpack_public_path__ + "static/media/T735MANB3.c45317fb.pdf";